import { render, staticRenderFns } from "./SalesReservation.vue?vue&type=template&id=5587888c&"
import script from "./SalesReservation.vue?vue&type=script&lang=js&"
export * from "./SalesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports